import React, { forwardRef, memo } from 'react'

const BackgroundSvg = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="572.65"
      height="466.05"
      viewBox="0 0 572.65 466.05"
      fill="none"
      {...props}>
      <g transform="scale(0.65)">
        <path
          d="M245.471 -90H906.983V716.723H316.462C277.255 716.723 245.471 684.939 245.471 645.731V-90Z"
          fill="url(#paint0_linear_2028_12)"
        />
        <path
          d="M360.132 152.017H173.623C169.867 152.017 151.091 152.017 138.574 121.975C123.474 85.736 173.623 70.6537 181.133 88.1782C205.166 35.1044 257.489 54.3817 259.993 88.1786C293.038 72.1564 295.876 101.113 291.286 121.975C358.379 113.964 365.139 138.665 360.132 152.017Z"
          fill="white"
        />
        <path
          d="M546.872 55.21H733.381C737.137 55.21 755.913 55.21 768.43 25.1683C783.53 -11.0709 733.381 -26.1532 725.871 -8.62869C701.838 -61.7024 649.515 -42.4252 647.011 -8.62825C613.965 -24.6505 611.128 4.30608 615.718 25.1683C548.625 17.1572 541.865 41.8582 546.872 55.21Z"
          fill="white"
        />
        <path
          d="M769.528 271.412H956.037C959.792 271.412 978.568 271.412 991.086 241.37C1006.19 205.131 956.037 190.049 948.527 207.573C924.493 154.499 872.171 173.777 869.667 207.574C836.621 191.551 833.784 220.508 838.374 241.37C771.28 233.359 764.521 258.06 769.528 271.412Z"
          fill="white"
        />
        <path
          d="M96.5745 342.031L317.226 282.908L383.134 528.88L162.482 588.003L96.5745 342.031Z"
          fill="#78BE20"
        />
        <path
          d="M67.5671 291.65L313.539 225.742L328.078 280.001L82.1057 345.909L67.5671 291.65Z"
          fill="#397615"
        />
        <path
          d="M189.435 259.72C189.432 216.954 225.92 189.298 237.298 206.28C251.172 226.988 224.969 251.797 189.435 259.72ZM189.435 259.72C151.234 241.34 146.139 189.985 161.83 182.119C188.837 168.578 202.471 245.781 189.435 259.72ZM189.435 259.72C156.997 273.112 111.964 251.17 118.891 232.683C131.326 199.499 189.137 257.157 189.435 259.72Z"
          stroke="#6C0CAE"
          strokeWidth="3.45534"
        />
        <path
          d="M205.622 315.442L214.169 368.057L282.126 417.021L323.745 359.258L255.789 310.294L205.622 315.442Z"
          fill="white"
        />
        <path
          d="M304.525 550.867H556.765V716.723H304.525V550.867Z"
          fill="white"
        />
        <path
          d="M540.819 696.029L456.56 606.153"
          stroke="#CEDC00"
          strokeWidth="3.45534"
        />
        <path
          d="M325.258 696.029L409.517 606.153"
          stroke="#CEDC00"
          strokeWidth="3.45534"
        />
        <path
          d="M427.19 638.978L304.525 550.867H556.765L427.19 638.978Z"
          fill="#46AD06"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M133.063 590.689C139.276 593.141 146.3 590.092 148.752 583.879C148.802 583.75 148.851 583.621 148.897 583.492L175.142 593.848L178.769 602.203L151.583 671.1L139.05 676.541L138.45 676.304L145.673 686.079L136.217 710.043L127.862 713.67L52.9741 684.121L49.3471 675.766L58.8029 651.801L70.0028 649.008L64.7128 636.823L91.8985 567.926L100.253 564.299L126.41 574.62C126.356 574.745 126.303 574.872 126.252 575.001C123.801 581.214 126.85 588.238 133.063 590.689Z"
          fill="#8712BF"
        />
        <circle
          cx="115.941"
          cy="634.081"
          r="24.7057"
          transform="rotate(21.5334 115.941 634.081)"
          stroke="white"
          strokeWidth="2.41874"
        />
        <rect
          x="112.344"
          y="619.661"
          width="3.45534"
          height="13.8214"
          rx="1.72767"
          transform="rotate(21.5334 112.344 619.661)"
          fill="white"
        />
        <rect
          x="125.201"
          y="624.734"
          width="3.45534"
          height="13.8214"
          rx="1.72767"
          transform="rotate(21.5334 125.201 624.734)"
          fill="white"
        />
        <path
          d="M102.45 630.615C104.297 636.915 112.026 647.766 128.163 640.761"
          stroke="white"
          strokeWidth="2.41874"
          strokeLinecap="round"
        />
        <circle cx="635.407" cy="636.419" r="78.6416" fill="#D15A19" />
        <mask
          id="mask0_2028_12"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="556"
          y="557"
          width="159"
          height="159">
          <circle cx="635.407" cy="636.419" r="78.6416" fill="#C27C00" />
        </mask>
        <g mask="url(#mask0_2028_12)">
          <path
            d="M563.676 599.243H598.23"
            stroke="white"
            strokeWidth="3.45534"
          />
          <path
            d="M570.586 685.626L605.14 685.626"
            stroke="white"
            strokeWidth="3.45534"
          />
          <path
            d="M546.399 644.161L589.591 644.161"
            stroke="white"
            strokeWidth="3.45534"
          />
        </g>
        <ellipse
          cx="650.06"
          cy="637.251"
          rx="72.5622"
          ry="79.4729"
          fill="#FFA300"
        />
        <path
          d="M553.844 281.964L570.389 220.218C574.587 204.55 590.692 195.252 606.36 199.45V199.45C622.028 203.649 631.326 219.753 627.128 235.422L610.583 297.167"
          stroke="#78BE20"
          strokeWidth="3.45534"
        />
        <path
          d="M370.287 483.185L480.121 230.013L660.352 278.305L648.109 557.628L370.287 483.185Z"
          fill="white"
        />
        <path
          d="M598.045 544.215L648.669 275.18L660.351 278.309L648.109 557.631L598.045 544.215Z"
          fill="#C4C4C4"
        />
        <path
          d="M585.958 415.772L449.116 379.105L538.402 335.062L585.958 415.772Z"
          fill="#72BF44"
        />
        <path
          d="M519.813 262.114L536.358 200.369C540.556 184.701 556.661 175.402 572.329 179.601V179.601C587.997 183.799 597.295 199.904 593.097 215.572L576.552 277.318"
          stroke="#78BE20"
          strokeWidth="3.45534"
        />
        <circle
          cx="70.8344"
          cy="262.558"
          r="6.91069"
          fill="#6C0CAE"
          stroke="#6C0CAE"
          strokeWidth="3.45534"
        />
        <circle
          cx="29.3704"
          cy="238.37"
          r="27.6427"
          fill="#6C0CAE"
          stroke="#6C0CAE"
          strokeWidth="3.45534"
        />
        <circle cx="684.614" cy="526.459" r="10.366" fill="white" />
        <circle cx="741.627" cy="507.455" r="36.2811" fill="white" />
        <circle cx="713.984" cy="476.357" r="29.3704" fill="white" />
        <path
          d="M698.192 250.102L698.907 256.821C699.319 260.693 702.001 263.945 705.724 265.086L712.185 267.065L705.465 267.78C701.594 268.191 698.342 270.874 697.201 274.597L695.222 281.058L694.507 274.338C694.095 270.467 691.413 267.214 687.69 266.074L681.229 264.094L687.949 263.38C691.82 262.968 695.072 260.285 696.213 256.563L698.192 250.102Z"
          fill="#FFA300"
        />
        <path
          d="M81.5843 523.074L80.8698 529.794C80.4581 533.666 77.7754 536.918 74.0528 538.058L67.5917 540.038L74.3113 540.752C78.1829 541.164 81.4351 543.847 82.5756 547.569L84.555 554.03L85.2696 547.311C85.6813 543.439 88.3639 540.187 92.0865 539.047L98.5476 537.067L91.828 536.352C87.9564 535.941 84.7043 533.258 83.5638 529.536L81.5843 523.074Z"
          fill="#FFA300"
        />
        <path
          d="M404.109 172.293L401.444 178.503C399.908 182.08 396.386 184.396 392.492 184.388L385.735 184.373L391.944 187.038C395.522 188.574 397.838 192.096 397.829 195.99L397.814 202.747L400.48 196.538C402.015 192.96 405.538 190.644 409.432 190.653L416.189 190.668L409.979 188.002C406.402 186.467 404.086 182.944 404.094 179.05L404.109 172.293Z"
          fill="#FFA300"
        />
        <path
          d="M677.781 226.962L678.319 232.025C678.629 234.942 680.65 237.392 683.455 238.252L688.323 239.743L683.26 240.281C680.343 240.592 677.893 242.613 677.034 245.417L675.542 250.285L675.004 245.223C674.694 242.306 672.673 239.855 669.868 238.996L665 237.505L670.063 236.966C672.98 236.656 675.43 234.635 676.289 231.83L677.781 226.962Z"
          fill="#FFA300"
        />
        <path
          d="M101.996 499.935L101.458 504.997C101.147 507.914 99.1262 510.365 96.3215 511.224L91.4535 512.715L96.5163 513.254C99.4332 513.564 101.883 515.585 102.743 518.39L104.234 523.258L104.773 518.195C105.083 515.278 107.104 512.828 109.909 511.968L114.777 510.477L109.714 509.939C106.797 509.628 104.347 507.607 103.487 504.803L101.996 499.935Z"
          fill="#FFA300"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2028_12"
            x1="576.227"
            y1="-90"
            x2="1326.48"
            y2="989.395"
            gradientUnits="userSpaceOnUse">
            <stop stopColor="#CEDC00" />
            <stop offset="1" stopColor="#78BE20" />
          </linearGradient>
        </defs>
      </g>
    </svg>
  )
)

BackgroundSvg.displayName = 'BackgroundSvg'

export default memo(BackgroundSvg)
